import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ParticipantStatus } from '@regigov/contracts';
import { applicationsApi, participantsApi } from '../../api/participants';
import { ProblemAlert, StatusBadge, formatDateTime } from '../../components/ui';

export function ParticipantsPage() {
  const [q, setQ] = useState('');
  const [status, setStatus] = useState<ParticipantStatus | ''>('');
  const list = useQuery({ queryKey: ['participants', q, status], queryFn: () => participantsApi.search(q, status || undefined) });
  const queue = useQuery({ queryKey: ['applications', 'submitted'], queryFn: () => applicationsApi.list('submitted') });

  return (
    <>
      <h1>Participants</h1>
      <p className="notice">
        {queue.data ? `${queue.data.items.length} application(s) awaiting assessment. ` : ''}
        <Link to="/cer/participants/applications">Open the applications queue</Link>
      </p>

      <div className="row">
        <label className="grow">
          Search
          <input name="q" placeholder="Legal or trading name, ABN or participant ID" value={q} onChange={(e) => setQ(e.target.value)} />
        </label>
        <label>
          Status
          <select value={status} onChange={(e) => setStatus(e.target.value as ParticipantStatus | '')}>
            <option value="">Any</option>
            {ParticipantStatus.options.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </label>
      </div>

      <ProblemAlert error={list.error} />
      {list.isLoading && <p className="muted">Loading…</p>}
      {list.data && list.data.items.length === 0 && <p className="muted">No participants match.</p>}
      {list.data && list.data.items.length > 0 && (
        <table className="table">
          <thead>
            <tr>
              <th>Legal name</th>
              <th>ABN</th>
              <th>Type</th>
              <th>Status</th>
              <th>Participant ID</th>
              <th>Last updated</th>
            </tr>
          </thead>
          <tbody>
            {list.data.items.map((p) => (
              <tr key={p.id}>
                <td>
                  <Link to={`/cer/participants/${p.id}`}>{p.legalName}</Link>
                  {p.tradingName && <span className="muted"> ({p.tradingName})</span>}
                </td>
                <td>{p.abn}</td>
                <td>{p.participantType}</td>
                <td>
                  <StatusBadge status={p.status} />
                </td>
                <td>
                  <code>{p.id}</code>
                </td>
                <td>{formatDateTime(p.updatedAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
